import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Empty } from "antd";
import * as React from "react";
import { classNames } from "src/common/classNames";

import { ZRoleAccess } from "../ZRoleAccess";
import { CheckerButton } from "./CheckerButton/CheckerButton";
import * as styles from "./EditRoleAccessList.module.less";
import { roleActions, SelectOfAccessedRoles } from "./SelectOfAccessedRoles";

type PropsEditRoleAccessList = {
  value?: ZRoleAccess[] | null;
  onChange?(newValue: ZRoleAccess[] | null | undefined): void;
};

export const EditRoleAccessList: React.FC<PropsEditRoleAccessList> = (
  props,
) => {
  const { value, onChange } = props;
  const [rolesSelect, setRolesSelect] = React.useState(false);
  const roles: ZRoleAccess[] = value ?? [];
  const onCellChange = (
    index: number,
    key: "canCreate" | "canDelete" | "canRead" | "canUpdate",
    flag: boolean,
  ) => {
    const newValue = roles.map((it, i) =>
      i === index ? { ...it, [key]: flag } : it,
    );
    onChange?.(newValue);
  };
  const onDelete = (index: number) => {
    const newValue = [...roles];
    newValue.splice(index, 1);
    onChange?.(newValue);
  };
  return (
    <div className={styles.box}>
      <div className={styles.header}>
        <div className={styles.title}>Права доступа</div>
        <Button icon={<PlusOutlined />} onClick={() => setRolesSelect(true)}>
          Добавить роль
        </Button>
      </div>
      <div className={styles.table}>
        <div className={classNames([styles.th, styles.leftColumn])}>Роль</div>
        <div className={classNames([styles.th, styles.record])}>Запись</div>
        <div className={styles.th} />
        <div className={classNames([styles.td, styles.leftColumn])} />
        <div className={styles.td}>CREATE</div>
        <div className={styles.td}>READ</div>
        <div className={styles.td}>UPDATE</div>
        <div className={styles.td}>DELETE</div>
        <div className={styles.td} />
        {roles.length === 0 && (
          <div className={styles.empty}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        )}
        {roles.map((roleRec, index) => (
          <React.Fragment key={roleRec.role.id}>
            <div className={classNames([styles.td, styles.leftColumn])}>
              {roleRec.role.label}
            </div>
            {roleActions.map((action) => (
              <div key={action} className={styles.tdButton}>
                <CheckerButton
                  value={roleRec[action]}
                  onChange={(flag) => onCellChange(index, action, flag)}
                />
              </div>
            ))}
            <div className={styles.tdButton}>
              <Button
                icon={<DeleteOutlined />}
                type="text"
                title="Удалить роль из таблицы"
                onClick={() => onDelete(index)}
              />
            </div>
          </React.Fragment>
        ))}
      </div>
      <SelectOfAccessedRoles
        open={rolesSelect}
        close={() => setRolesSelect(false)}
        selected={roles}
        onSelect={(list) => {
          onChange?.([...roles, ...list]);
        }}
      />
    </div>
  );
};
